import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { useGetMeContext } from "@/hooks/useAuth";
import { ADMIN_ROLES } from "@/constant/auth.constant";
import { IS_DEVELOPMENT } from "@/config/env.config";
import { UserKind } from "@/enum/common.enum";

export default function DevDebugBar() {
  const { user } = useAuth() || {};
  const [open, setOpen] = useState(true);
  const { data: ctx } = useGetMeContext({ enabled: !!user });

  if (!IS_DEVELOPMENT || !ctx) return null;
  // Only show to admin-level internal users
  if (!ctx.membership || !ADMIN_ROLES.has(ctx.membership.role)) return null;

  const org = ctx.organization as { name?: string; id?: string; plan?: string; status?: string } | null;

  const scope = ctx.kind === UserKind.INTERNAL
    ? `${org?.name || "—"} · ${ctx.membership?.role}`
    : `external · ${ctx.deal_participations?.length || 0} deal(s)`;

  return (
    <div
      className="fixed bottom-3 left-3 z-[60] font-mono text-[11px] bg-ink text-linen border border-rust shadow-lg"
      data-testid="dev-debug-bar"
    >
      <div className="flex items-center gap-3 px-3 py-1.5 cursor-pointer" onClick={() => setOpen(!open)}>
        <span className="uppercase tracking-widest text-rust">[DEV · acting as]</span>
        <span>{scope}</span>
        <span className="opacity-50">{open ? "▾" : "▸"}</span>
      </div>
      {open && (
        <div className="border-t border-rust/40 px-3 py-2 space-y-0.5 max-w-xs">
          <div><span className="opacity-60">user:</span> {ctx.user?.email}</div>
          <div><span className="opacity-60">kind:</span> {ctx.kind}</div>
          {org && (
            <>
              <div><span className="opacity-60">org_id:</span> {org.id?.slice(0, 8)}…</div>
              <div><span className="opacity-60">plan:</span> {org.plan} ({org.status})</div>
            </>
          )}
          {ctx.membership && (
            <div><span className="opacity-60">role:</span> {ctx.membership.role}</div>
          )}
          {ctx.deal_participations?.length > 0 && (
            <div><span className="opacity-60">deals:</span> {ctx.deal_participations.length}</div>
          )}
        </div>
      )}
    </div>
  );
}
